import { render, staticRenderFns } from "./SelectParceiro.vue?vue&type=template&id=5b95db79"
import script from "./SelectParceiro.vue?vue&type=script&lang=js"
export * from "./SelectParceiro.vue?vue&type=script&lang=js"
import style0 from "./SelectParceiro.vue?vue&type=style&index=0&id=5b95db79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports